import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { layout } from '../../../utils/theme';
import { PdfViewer } from '../pdfViewer/PdfViewer';

const useStyles = makeStyles({
  fullScreenDialog: {
    margin: layout.APP_WINDOW_CONTROLS_HEIGHT,
  },
  dialogTitleContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    padding: 5,
  },
  containerWithNoPadding: {
    padding: 0,
  },
});

interface PdfReaderProps {
  pdfUrl?: string;
  isOpen?: boolean;
  toggleViewer?: () => void;
}

export const PdfReader = ({
  pdfUrl = '',
  isOpen = false,
  toggleViewer = () => {},
}: PdfReaderProps) => {
  const classes = useStyles();

  const closeViewer = () => {
    toggleViewer();
  };

  return (
    <Dialog
      open={isOpen}
      fullScreen
      onClose={toggleViewer}
      className={classes.fullScreenDialog}
    >
      <DialogTitle className={classes.dialogTitleContainer}>
        <IconButton aria-label="close" onClick={closeViewer} size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers className={classes.containerWithNoPadding}>
        <PdfViewer pdfUrl={pdfUrl} />
      </DialogContent>
    </Dialog>
  );
};
